module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	var _ = {
		MAXFAILSTOCAPTCHA: 5,
		LOGINAPINAME: 'loginApi'
	};

	fox.registerWidget('User_Login', {
		configure: function(options) {
			this.registerOptions('', {
				captchaAlias: 'default',
				captchaContainer: false,
				useCaptcha: false,
				reloadCaptchaOnError: false,
				captchaBlockSelector: false,
				errorRedirect: true,
				customLoginRedirect: false,
				'widgets.lform': {
					widget: 'Form',
					formElements: {
						'le': {
							element: '[name=le]'
						},
						'password': {
							element: '[name=password]'
						},
						'captcha': {
							element: '[name=captcha]'
						}
					},
					resetOnBuilt: false,
					submit: {
						target: '.auth-form',
						event: 'submit'
					}
				},
				handleDom: {
					openLogin: {
						event: 'click',
						target: '#auth-link',
						callback: 'openLogin'
					},
					reloadCaptcha: {
						event: 'click',
						target: '.reload-captcha',
						callback: '#captcha:loadCaptcha'
					},
					report: {
						event: 'click',
						target: '#_reportProblem',
						callback: '_report'	
					}
				},
				handleWom: {
					formSubmit: {
						widget: '#lform',
						event: 'submit',
						callback: 'formSubmit'
					},
					addedToDom: {
						widget: '@this',
						event: 'addedToDom',
						callback: '_startCaptcha'
					}
				}
			});
			this.callParent('configure', arguments);
		},

		init: function() {
			$('body').on('click', function(e){ 
				if($(e.target).parents('#auth').length < 1){
					$('#auth').removeClass('auth-opened').addClass('auth-closed');
					$('#auth').removeClass('stem')
				}
			});

			this.callParent('init', arguments);
		},
		
		running: function () {
			/* var captcha = fox.getEnv('showCaptchaOnLogin') === undefined ? this.getOption('useCaptcha') : fox.getEnv('showCaptchaOnLogin');
			if ( captcha ){
				this._showCaptcha();
			}  */

			this.callParent('running', arguments);
		},

		openLogin: function() {
			$(this.options.container).removeClass('auth-closed').addClass('auth-opened').addClass('stem');
		},

		formSubmit: function(userData) {
			var data;

			if (fox.Navigator.get(0) != 'login') {
				fox.site.setCustomData('hashOnLoginSuccess', fox.Navigator.getAll());
			}

			if (this.getOption('useCaptcha')) {
				data = {memberFields: ['login'], captchaId: this.rwom1('.Captcha').captchaId};
			} else {
				data = {memberFields: ['login']};
			}

			fox.each(userData, function(val, key) {
				if (val) {
					data[key] = window.encodeURIComponent(fox.trim(val));
				}
			}, this);

			$(this.options.container).removeClass('auth-opened').addClass('auth-closed');

			var api = this.getApi(_.LOGINAPINAME, {
				httpMethod: 'post',
				method: 'site.authorizer.auth',
				secure: fox.getEnv('ah') && [fox.getEnv('ah').split('').reverse().join(''), fox.getEnv('aet')]
			});
			
			this.waitEvent(api, 'success', fox.bind(this.formSubmitted, this));
			this.waitEvent(api, ['error', 'failure'], fox.bind(this.formSubmitError, this));

			api.send(data, true);
		},

		formSubmitted: function(data) {
			var response = data.answer.response;
			var redirect = this.getOption('customRedirectOnLogin');
			
			if (!response.member) {
				fox.log('login failed: ' + response.message);

				if (this.getOption('errorRedirect')) {
					fox.site.gotoPage('login');
				}

				fox.site.dispatchEvent('loginError', response);

				return;
			}

			var redirectTo = fox.Navigator.getAll();

			fox.log('logged in, hash is "' + response.hash + '", member is ' + response.member.collection + ', redirecting to ' + redirectTo[0]);
			
			fox.site.login(response.member, response.hash, 'home');

			if (redirect) {
				fox.site.gotoPage(redirect, {skipEvent: true});
			}
			
			this.dispatchEvent('loginSuccess');
			
			if(response.downgradedToFree !== undefined) {
				fox.utils.localStorage('setItem', 'exPremiumUser', 1);
			}

			window.location.reload(true);
		},

		formSubmitError: function(data) {
			var response = data.answer;

			if (!response) return false;
			
			fox.site.dispatchEvent('loginError', response);

			if ([3,33].includes(response.code) && response.type === 0) {
				this.setOption('useCaptcha', true);
				if(!this.wom1('#captcha')){
					this._embedCaptcha()
				}
				this._showCaptcha()
			}

			this.hookWrapper('insertErrorMessage', response);
		},

		getErrorContainer: function () {
			return $(this.element[0]).find('#message');
		},

		getDefaultErrorContainer: function () {
			return $('.login-form-error-message.default');
		},

		insertErrorMessage: function (response) {
			if (response.reason){
				this.getErrorContainer().text(response.reason);
			}
		},

		toggleErrorBlock: function (state) {
			var block = this.getErrorContainer();

			if (fox.isObject(state)) {
				this[(state.action === true ? 'showErrorBlock' : 'hideErrorBlock')]();
				
				return;
			}

			if (block.hasClass('show')) {
				this.hideErrorBlock();

				return;
			}

			this.showErrorBlock();
		},

		showErrorBlock: function () {
			this.getErrorContainer().addClass('show');
		},

		hideErrorBlock: function () {
			this.getErrorContainer().removeClass('show');
		},


		showDefaultErrorBlock: function () {
			this.getDefaultErrorContainer().addClass('show');
		},

		hideDefaultErrorBlock: function () {
			this.getDefaultErrorContainer().removeClass('show');
		},

		_report: function (argument) {
			this.hookWrapper('report');
		},

		_embedCaptcha: function () {
			this.embedWidget('captcha', 'Captcha', {
				'embed.container': this.getOption('captchaContainer') || '#captcha',
				captchaAlias: this.getOption('captchaAlias') || 'default'
			}).run();
		},

		_startCaptcha: function() {
			if (fox.getEnv('showCaptchaOnLogin')){
				this.setOption('useCaptcha', true)
				this._embedCaptcha();
				this._showCaptcha();
			}else{
				this._embedCaptcha();
			}
		},

		_showCaptcha: function () {
			var wCaptcha = this.wom1('#captcha');
			if (!wCaptcha._indom) {
				wCaptcha.render();
				this.handleEvent(wCaptcha, 'addedToDom', fox.bind(function () {
					wCaptcha.loadCaptcha();
					$(this.dom1(this.getOption('captchaBlockSelector') || '#captchaBlock')).show();
				}, this), {once: true});
			} else if (this.getOption('reloadCaptchaOnError') === true) {
				wCaptcha.loadCaptcha();
				$(this.dom1(this.getOption('captchaBlockSelector') || '#captchaBlock')).show();
			}
		}
	});
})(fox);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/publisher/widget/user/login.js
// module id = 480
// module chunks = 4